/**
 * Price and currency conversion constants
 */

export const CENTS_PER_DOLLAR = 100;

/**
 * Discount price type constants
 */
export const DISCOUNT_PRICE_LIST_PRICE = 'List Price';
export const DISCOUNT_PRICE_NURSE_PRICE = 'Nurse Price';
export const DISCOUNT_PRICE_DOCTOR_PRICE = 'Doctor Price';
export const DISCOUNT_PRICE_RRP = 'RRP';

/**
 * Discount type constants
 */
export const DISCOUNT_TYPE_PERCENTAGE = 'percentage';
export const DISCOUNT_TYPE_FIX = 'fix';

/**
 * Product type constants
 */
export const PRODUCT_TYPE_BUNDLE = 'bundle';
export const PRODUCT_TYPE_BUNDLED_ITEMS = 'bundled-items';

